const email = /^\w+[\w-_.+]*@([\w]+[\w-].)+[\w]+$/;

export default email;
